<template>
	<div>
		<div class="avatar-picker" role="radiogroup">
			<div v-for="num in numRows" :key="num" class="avatar-row">
				<button
					v-for="avatar in currentItems.slice(
						(num - 1) * itemsPerRow,
						num * itemsPerRow
					)"
					:key="avatar.id"
					tabindex="0"
					class="avatar-option"
					:class="{ selected: isAvatarSelected(avatar) }"
					:aria-label="avatar.description"
					role="radio"
					:aria-checked="isAvatarSelected(avatar).toString()"
					@mousedown.prevent
					@click="selectAvatarPreset(avatar)"
				>
					<div class="option-content">
						<img :src="avatar.smallImageBase64" alt="" />
					</div>
				</button>
			</div>
		</div>

		<ja-pagination
			v-if="paginated && numPages > 1"
			:curr-page="currentPage"
			:num-pages="numPages"
			@goPrevPage="onGoPrevPage"
			@goNextPage="onGoNextPage"
		></ja-pagination>
	</div>
</template>
<script>
import Pagination from '@/components/ui/Pagination';
const MAX_ITEMS_PER_ROW = 3;

export default {
	components: {
		jaPagination: Pagination
	},
	props: {
		value: {
			type: Object,
			default: null
		},
		data: {
			type: Array,
			default: () => {
				return [];
			}
		},
		paginated: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			currentPage: 1,
			itemsPerPage: 9,
			itemsPerRow: MAX_ITEMS_PER_ROW
		};
	},
	computed: {
		numRows() {
			return this.paginated
				? MAX_ITEMS_PER_ROW
				: this.data.length / MAX_ITEMS_PER_ROW;
		},
		numPages() {
			return Math.ceil(this.data.length / this.itemsPerPage);
		},
		currentItems() {
			if (this.paginated) {
				return this.data.slice(
					(this.currentPage - 1) * this.itemsPerPage,
					this.currentPage * this.itemsPerPage
				);
			}
			return this.data;
		}
	},
	methods: {
		isAvatarSelected(avatar) {
			return !!this.value && this.value.id == avatar.id;
		},

		onGoPrevPage() {
			this.currentPage--;
		},

		onGoNextPage() {
			this.currentPage++;
		},
		selectAvatarPreset(preset) {
			this.$emit('input', preset);
		}
	}
};
</script>
<style lang="scss" scoped>
.avatar-picker {
	width: 100%;
	display: flex;
	flex-wrap: wrap;
	width: 100%;

	.avatar-row {
		display: flex;
		height: 90px;

		@media (min-width: $breakpoint-mid) {
			height: 120px;
		}

		@media (min-width: $breakpoint-max) {
			height: 140px;
		}
		width: 100%;
	}

	.avatar-option {
		position: relative;
		width: 33.33%;
		border-radius: 100%;
		background-color: transparent;
		border: 0;

		.option-content {
			display: flex;
			align-items: center;
			justify-content: center;
			position: absolute;
			top: 0;
			bottom: 0;
			left: 0;
			right: 0;
			margin: auto;
			width: 75%;

			img {
				width: 100%;
			}
		}

		&:before {
			content: '';
			position: absolute;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
			border: 2px solid #dfe9f4;
			border-radius: 50%;
			margin: 8px;
		}

		@media (any-hover: hover) {
			&:hover {
				cursor: pointer;
				&:before {
					border-color: $hover-state;
				}
			}
		}

		&:active {
			&:before {
				border-color: $tapped-state;
			}
		}

		&.selected {
			&:before {
				border-color: $primary-state;
			}
		}
	}
}
</style>
